import React, { useCallback, useEffect, useState } from 'react';
import { apiFetch } from '../api';
import './AvatarModeration.css';

function AvatarModeration() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [busyId, setBusyId] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await apiFetch('/admin/avatars/pending');
      const data = await res.json();
      if (!res.ok || !data.ok) throw new Error(data.message || 'Failed to load');
      setItems(data.avatars || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const run = async (userId, action) => {
    setBusyId(userId);
    try {
      const res = await apiFetch(`/admin/avatars/${userId}/${action}`, { method: 'POST' });
      const data = await res.json();
      if (!res.ok || !data.ok) throw new Error(data.message || 'Action failed');
      setItems((prev) => prev.filter((i) => i.userId !== userId));
    } catch (err) {
      setError(err.message);
    } finally {
      setBusyId(null);
    }
  };

  if (loading) return <p>Loading pending avatars…</p>;
  if (error) return <p className="avatar-mod-error">{error}</p>;

  return (
    <div className="avatar-moderation">
      <h2>Avatar approvals</h2>
      {items.length === 0 ? (
        <p className="avatar-mod-empty">No avatars awaiting approval.</p>
      ) : (
        <ul className="avatar-mod-list">
          {items.map((item) => (
            <li key={item.userId} className="avatar-mod-item">
              <img src={item.avatarUrl} alt="" className="avatar-mod-preview" />
              <div className="avatar-mod-meta">
                <strong>{item.username}</strong>
                <span>User #{item.userId}</span>
              </div>
              <div className="avatar-mod-actions">
                <button
                  type="button"
                  className="avatar-mod-btn avatar-mod-btn--approve"
                  disabled={busyId === item.userId}
                  onClick={() => run(item.userId, 'approve')}
                >
                  Approve
                </button>
                <button
                  type="button"
                  className="avatar-mod-btn avatar-mod-btn--reject"
                  disabled={busyId === item.userId}
                  onClick={() => run(item.userId, 'reject')}
                >
                  Reject
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default AvatarModeration;